import { graphql } from "api/cms-website/generated";

import { ButtonFragment } from "../primitives/button";
import { TableWithCheckmarksRowFragment } from "../elements/tableWithCheckmarksRow";

export const TableWithCheckmarksFragment = graphql(/* GraphQL */ `
    fragment TableWithCheckmarksFragment on ComponentComponentsTableWithCheckmarks {
        id
        noMarginBottom
        tableWithCheckmarksTitle: title
        tableWithCheckmarksColumns: columns
        tableWithCheckmarksCta: cta {
            ...ButtonFragment
        }
        tableWithCheckmarksRows: rows {
            ...TableWithCheckmarksRowFragment
        }
    }
    ${ButtonFragment}
    ${TableWithCheckmarksRowFragment}
`);
